import { colors } from './colors';
import { gridBreakpoints } from './gridBreakpoints';

export default {
  colors,
  gridBreakpoints,
};
